// extracted by mini-css-extract-plugin
module.exports = {"impegnoTemplate":"ImpegnoTemplate_impegnoTemplate__VbAXj","head":"ImpegnoTemplate_head__eggsr","rotation":"ImpegnoTemplate_rotation__qw81n"};